import {ChartType, ProjectFeatureFlag} from 'common/report/constants';
import {AnalysisType, ChartPlotStyle, InsightsResourceType} from 'common/report/insights/util/types';
import {CurrentProject} from 'common/report/model-resources/projects';
import {BookmarkType} from 'common/report/queries/app-api/bookmark-client';
import {properties} from 'common/report/util/settings-tracking';

import {CUSTOM_ALERT_TYPE} from './constants';
import {CustomAlert, SlackWebhookError, SlackWebookSubscription, SubscriptionType} from './types';

export function validateSlackWebhook(subscription: SlackWebookSubscription): SlackWebhookError {
  if (subscription.type !== SubscriptionType.SlackWebhook) {
    throw Error(`Incorrect subscription type`);
  }

  let error = null;
  if (!subscription.data.slack_webhook_url.startsWith(`https://hooks.slack.com/services/`)) {
    error = SlackWebhookError.InvalidUrl;
  }
  return error;
}

export function customAlertCoreTrackingProperties(customAlert: CustomAlert) {
  const {bookmarkId, id, projectId} = customAlert;
  return {[properties.projectId]: projectId, [properties.bookmarkId]: bookmarkId, [properties.customAlertId]: id};
}

export function customAlertTrackingProperties(customAlert: CustomAlert) {
  const {condition, subscriptions} = customAlert;
  const emailSubscriptions = (subscriptions || []).filter((sub) => sub.type === SubscriptionType.Email);
  const webhookSubscriptions = (subscriptions || []).filter((sub) => sub.type === SubscriptionType.SlackWebhook);
  const channelSubscriptions = (subscriptions || []).filter((sub) => sub.type === SubscriptionType.SlackChannel);
  return {
    ...customAlertCoreTrackingProperties(customAlert),
    'Condition Threshold': condition.value,
    'Condition Operator': condition.op,
    'Condition Type': condition.type,
    '# of Email recipients': emailSubscriptions.length,
    '# of Recipients': subscriptions.length,
    '# of Webhook Recipients': webhookSubscriptions.length,
    '# of Slack Recipients': channelSubscriptions.length,
    'Has Email Recipients': !!subscriptions.length,
    'Has Webhook Recipients': !!webhookSubscriptions.length,
    'Has Slack Recipients': !!channelSubscriptions.length,
    ...(condition.type === CUSTOM_ALERT_TYPE.anomaly
      ? {
          Confidence: condition.confidence,
          'Training Mode': condition.trainingMode,
        }
      : {}),
  };
}

export function isAnomalyDetectionVizEnabled(currentProject: CurrentProject) {
  return currentProject ? currentProject?.hasFeatureFlag(ProjectFeatureFlag.AnomalyDetectionViz) : false;
}

export function isValidAnomalyDetectionBookmark(
  bookmarkType: BookmarkType,
  bookmarkParams: {
    sections: any;
    displayOptions?: any;
    timeComparison?: any;
    liftComparison?: any;
  },
) {
  if (bookmarkType === BookmarkType.Insights) {
    const displayOptions = bookmarkParams?.displayOptions;
    const bookmarkChartType = displayOptions?.chartType;
    const bookmarkPlotStyle = displayOptions?.plotStyle;
    const bookmarkAnalysisType = displayOptions?.analysis;
    const bookmarkHasTimeComparison = !!bookmarkParams?.timeComparison;
    const bookmarkHasLiftComparison = !!bookmarkParams?.liftComparison;
    const isCohortOvertime = bookmarkParams?.sections?.show?.some(
      (showElement) => showElement.resourceType === InsightsResourceType.Cohorts,
    );
    const isValid = !(
      bookmarkChartType !== ChartType.Line ||
      bookmarkPlotStyle !== ChartPlotStyle.Standard ||
      bookmarkHasLiftComparison ||
      bookmarkHasTimeComparison ||
      bookmarkAnalysisType === AnalysisType.Rolling ||
      bookmarkAnalysisType === AnalysisType.Cumulative ||
      isCohortOvertime
    );
    return isValid;
  } else {
    return false;
  }
}
